import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent, ISelect } from '@tecalisdev/infinity';
import { IToggleAccept } from '@tecalisdev/infinity/lib/interfaces/toggleAccept';
import { IFormFieldConfig, IFormStepConfig } from '../../../models/user-identification';
import {
	coerceProvinceSelectField,
	getVisibleDynamicFormFields,
} from '../../../utils/dynamic-form-field.util';
import { DynamicFormFieldComponent } from '../dynamic-form-field/dynamic-form-field.component';

@Component({
	selector: 'app-dynamic-form-step',
	imports: [ReactiveFormsModule, TranslatePipe, ButtonComponent, DynamicFormFieldComponent],
	templateUrl: './dynamic-form-step.component.html',
	styleUrl: './dynamic-form-step.component.scss',
})
export class DynamicFormStepComponent {
	@Input({ required: true }) step!: IFormStepConfig;
	@Input({ required: true }) stepForm!: FormGroup;
	@Input() wide = false;
	@Input() showBackActions = false;
	@Input() apiError: string | null = null;
	@Input({ required: true }) stepTitle = '';
	@Input({ required: true }) stepDescription = '';
	@Input({ required: true }) resolveLocalizedText!: (value?: unknown) => string;
	@Input() stepFieldOptions: Record<string, ISelect[]> = {};
	@Input() stepFieldSelectSearch: Record<string, boolean> = {};
	@Input() stepFieldSelectPlaceholder: Record<string, string> = {};
	@Input() stepFieldSelectDisabled: Record<string, boolean> = {};
	@Input() countryProvinceCascade = false;
	@Input() legalToggleOptions: Record<string, IToggleAccept[]> = {};
	/** Errores visibles solo tras Continuar (NIF-824). */
	@Input() showValidationErrors = false;

	@Output() legalToggleChange = new EventEmitter<{ controlKey: string; options: IToggleAccept[] }>();
	@Output() fileSelected = new EventEmitter<{ fieldName: string; files: FileList }>();

	public get visibleFields(): IFormFieldConfig[] {
		return getVisibleDynamicFormFields(this.step).map((field) =>
			coerceProvinceSelectField(field, this.countryProvinceCascade),
		);
	}

	public fieldOptions(field: IFormFieldConfig): ISelect[] {
		return this.stepFieldOptions[field.uuid] ?? [];
	}

	public selectPlaceholder(field: IFormFieldConfig): string {
		return this.stepFieldSelectPlaceholder[field.uuid] ?? '';
	}

	public usesSelectSearch(field: IFormFieldConfig): boolean {
		return this.stepFieldSelectSearch[field.uuid] ?? false;
	}

	public isSelectDisabled(field: IFormFieldConfig): boolean {
		return this.stepFieldSelectDisabled[field.uuid] ?? false;
	}
}
